export default "__VITE_ASSET__K8gCwcQc__"